<template>
    <div>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-input
                    label="Nome"
                    v-model="data.model.cidadao.nome"
                    disabled
                    uppercase
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-input
                    label="Nome social"
                    v-model="data.model.cidadao.nomeSocial"
                    disabled
                    uppercase
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-input
                    label="N° CNS"
                    v-model="data.model.cidadao.cns"
                    v-mask="mask.cns"
                    disabled
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    label="CPF"
                    v-model="data.model.cidadao.cpf"
                    v-mask="mask.cpf"
                    disabled
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    label="Não possui CPF"
                    :value="data.model.cidadao.naoPossuiCpf ? 'Sim' : 'Não'"
                    disabled
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    label="DNV"
                    :value="data.model.cidadao.dnv"
                    disabled
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-input
                    label="Justificativa para ausência do CPF"
                    :value="data.model.cidadao.justificativaNaoPossuiCpf"
                    disabled
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    label="Estado civil"
                    :value="data.model.cidadao.estadoCivil"
                    disabled
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    label="Tipo sanguíneo"
                    :value="data.model.cidadao.tipoSanguineo"
                    disabled
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-date-picker
                    label="Data de nascimento"
                    :max-date="data.form.dataAtual"
                    v-model="data.model.cidadao.dataNascimento"
                    disabled
                    right
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    :options="data.form.nacionalidades"
                    label="Nacionalidade"
                    show-default-option
                    text-field="descricao"
                    v-model="data.model.cidadao.nacionalidadeId"
                    default-option-text="Selecione"
                    disabled
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="3" v-if="!isNaturalizadoBrasileiro">
                <rkm-form-date-picker
                    label="Data de naturalização"
                    v-model="data.model.cidadao.dataNaturalizacao"
                    disabled
                    right
                />
            </rkm-col>

            <rkm-col cols="3" v-if="!isNaturalizadoBrasileiro">
                <rkm-form-input
                    label="Portaria de naturalização"
                    v-model="data.model.cidadao.portariaNaturalizacao"
                    disabled
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-radio-group
                    v-model="data.model.cidadao.ativo"
                    label="Status"
                    :validations="validations.ativo"
                >
                    <rkm-form-radio :value="true">Ativo</rkm-form-radio>
                    <rkm-form-radio :value="false">Inativo</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-radio-group
                    v-model="data.model.cidadao.responsavel"
                    label="Responsável familiar?"
                    @change="handleResponsavel()"
                    :disabled="data.form.responsaveis.length == 0
                        || data.model.informacao.saidaCidadaoId == enums.saidaCidadao.OBITO"
                >
                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-select
                    :options="data.form.responsaveis"
                    label="Responsável"
                    show-default-option
                    text-field="nome"
                    v-model="data.model.cidadao.responsavelCidadaoId"
                    :default-option-text="
                        data.model.cidadao.responsavel
                            ? 'O próprio cidadão é o responsável'
                            : data.form.responsaveis.length == 0
                                ? 'Nenhum responsável cadastrado'
                                : 'Selecione'
                    "
                    value-field="id"
                    :disabled="data.model.cidadao.responsavel || data.form.responsaveis.length == 0"
                    :validations="!data.model.cidadao.responsavel == true ? validations.responsavelFamiliar : {}"
                    @change="handleOcupacaoResponsavel()"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-input
                    ref="rendaMensal"
                    label="Renda mensal"
                    v-model="data.model.cidadao.rendaMensal"
                    v-money="money"
                    prepend="R$"
                />
            </rkm-col>
        </rkm-row>


        <rkm-row cols="12">
            <rkm-col cols="6" v-if="data.model.cidadao.responsavelCidadaoId">
                <rkm-form-input-autocomplete
                    :searchFields="localForm.autocompleteFields.ocupacao"
                    :repository="repositories.ocupacao"
                    v-model="data.model.cidadao.ocupacao"
                    :textField="l => `${l.codigo} - ${l.nome}`"
                    :validations="validations.ocupacao"
                    label="Ocupação do responsável"
                    uppercase
                />
            </rkm-col>

            <rkm-form-input
                label="Unidade/Área/Microárea do Usuário SUS"
                v-model="data.model.cidadao.unidadeAreaSus"
                disabled
            >
                <rkm-input-group-append slot="append">
                    <rkm-input-group-text>
                        <rkm-form-checkbox
                            :checked="data.model.cidadao.foraArea"
                            disabled
                        >
                            Fora de área
                        </rkm-form-checkbox>
                    </rkm-input-group-text>
                </rkm-input-group-append>
            </rkm-form-input>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12" class="text-right">
                <rkm-button
                    color="primary"
                    :disabled="!data.model.cidadao.pacienteId"
                    @click="atualizarCadastro"
                >
                    Atualizar Cadastro
                </rkm-button>
            </rkm-col>
        </rkm-row>
    </div>

</template>

<script>

//Enums
import saidaCidadao from '@/enums/atencao-basica/saidaCidadao'
import nacionalidade from '@/enums/cadastro/cidadao/nacionalidade'

//Directives
import { VMoney } from 'v-money'

// Mixins
import { repository, object, data, mask } from '@/mixins'

export default {
    directives: { money: VMoney },
    computed: {
        validations() {

            return {
                responsavelFamiliar: {
                    required: true,
                },
                ativo: {
                    required: true,
                },
                profissao: {
                    min: 3,
                    max: 250,
                    termo_invalido: this.data.form.termosInvalidos,
                },
            }
        },
        isNaturalizadoBrasileiro() {

            return this.data.model.cidadao.nacionalidadeId == this.enums.nacionalidade.NATURALIZADO_BRASILEIRO
        },
    },
    created() {
        this.repositories.ocupacao = this.getConectaSusRepository('sigtap.ocupacao')
    },
    methods: {
        atualizarCadastro() {
            const rota = this.$router.resolve({
                name: 'cadastro-paciente-edit',
                params: { id: this.data.model.cidadao.pacienteId },
            })

            window.open(rota.href, '_blank')
        },
        handleResponsavel() {

            if (this.data.model.cidadao.responsavel) {

                this.data.model.cidadao.responsavelCidadaoId = null
                this.data.model.informacao.parentescoResponsavelId = null
            } else {

                this.data.model.cidadao.responsavelCidadaoId = this.data.form.responsaveis.length == 1
                    ? this.data.form.responsaveis[0].id : null
            }
        },
        handleOcupacaoResponsavel() {
            this.data.model.cidadao.ocupacao = null

            const { responsavelCidadaoId } = this.data.model.cidadao
            if (!responsavelCidadaoId) return

            const cidadaoResponsavel = this.data.form.responsaveis
                .find(responsavel => responsavel.id === responsavelCidadaoId)

            if (cidadaoResponsavel && cidadaoResponsavel.ocupacaoId) {
                this.data.model.cidadao.ocupacao = {
                    id: cidadaoResponsavel.ocupacaoId,
                    codigo: cidadaoResponsavel.ocupacaoCodigo,
                    nome: cidadaoResponsavel.ocupacaoNome,
                }
            }
        },
        selecionarResponsavel() {
            const cidadao = this.data.model.cidadao
            const responsaveis = this.data.form.responsaveis || []

            if (cidadao.responsavel || !responsaveis.length) return

            let opcao = responsaveis.find(r => String(r.id) === String(cidadao.responsavelCidadaoId))

            if (!opcao && responsaveis.length === 1) {
                opcao = responsaveis[0]
            }

            if (opcao && cidadao.responsavelCidadaoId !== opcao.id) {
                this.$set(cidadao, 'responsavelCidadaoId', opcao.id)
            }
        },
    },
    data: () => ({
        money: {
            decimal: ',',
            thousands: '.',
            prefix: '',
            suffix: '',
            precision: 2,
            masked: false
        },
        enums: {
            saidaCidadao,
            nacionalidade
        },
        repositories: {},
        localForm: {
            autocompleteFields: {
                ocupacao: [
                    { key: 'codigo', searchable: true },
                    { key: 'nome', searchable: true },
                ],
            },
        },
    }),
    mixins: [ repository, object, data, mask ],
    props: {
        data: { type: Object, required: false, },
    },
    watch: {
        'data.form.responsaveis': {
            immediate: true,
            deep: true,
            handler() {
                this.$nextTick(() => this.selecionarResponsavel())
            },
        },
        'data.model.cidadao.responsavel'() {
            this.$nextTick(() => this.selecionarResponsavel())
        },
        'data.model.cidadao.rendaMensal': function (rendaMensal) {

            if (!rendaMensal) {

                this.$refs.rendaMensal.$el.getElementsByTagName('input')[0].value = 0
            }
        },
    }
}
</script>